(function () {
  function scrollTabIntoView(tab, tabsContainer, tabs, behavior) {
    if (!tab || !tabsContainer) return;

    var scrollBehavior = behavior || 'smooth';
    var peek = 24;
    var index = Array.prototype.indexOf.call(tabs, tab);
    var scrollWidth = tabsContainer.scrollWidth;
    var clientWidth = tabsContainer.clientWidth;
    var maxScroll = scrollWidth - clientWidth;

    if (maxScroll <= 0) return;

    var target;

    if (index === 0) {
      target = 0;
    } else if (index === tabs.length - 1) {
      target = maxScroll;
    } else {
      target = tab.offsetLeft - peek;
    }

    tabsContainer.scrollTo({
      left: Math.max(0, Math.min(target, maxScroll)),
      behavior: scrollBehavior,
    });
  }

  function initPurecoreProof(root) {
    var tabsContainer = root.querySelector('[data-purecore-tabs]');
    var tabs = root.querySelectorAll('[data-purecore-tab]');
    var panels = root.querySelectorAll('[data-purecore-panel]');
    if (!tabs.length || !panels.length) return;

    var activateTab = function (tab) {
      var index = tab.getAttribute('data-tab-index');

      tabs.forEach(function (item) {
        var isActive = item.getAttribute('data-tab-index') === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-tab-index') === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      window.requestAnimationFrame(function () {
        scrollTabIntoView(tab, tabsContainer, tabs, 'smooth');
      });
    };

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    var activeTab = root.querySelector('[data-purecore-tab].is-active');
    if (activeTab && tabsContainer) {
      window.requestAnimationFrame(function () {
        scrollTabIntoView(activeTab, tabsContainer, tabs, 'instant');
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-purecore-proof]').forEach(initPurecoreProof);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var proof = event.target.querySelector('[data-purecore-proof]');
    if (proof) initPurecoreProof(proof);
  });
})();
